import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import PaymentCourseDetails from '@ts-core/components/Invoices/PaymentCourseDetails';
import BackButton from '@ts-core/components/BackButton';

import { useBilledCourse, useCourseCurrentPeriodDetails, useAcademyCourseInvoice } from 'modules/academies/hooks';

const CourseBillingPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const { courseId, invoiceId } = useParams();
  const { course } = useBilledCourse({ courseId });
  const { currentPeriod, onDownloadPeriodData } = useCourseCurrentPeriodDetails({ courseId });
  const { invoice } = useAcademyCourseInvoice({ courseId, invoiceId });

  const onSelectInvoice = useCallback(
    (newInvoice) => {
      history.push(`/billing-legacy/courses/${courseId}/${newInvoice._id}`);
    },
    [history, courseId]
  );

  const onSelectCurrentPeriod = useCallback(() => {
    history.push(`/billing-legacy/courses/${courseId}`);
  }, [history, courseId]);

  const onGoBack = useCallback(() => {
    history.push(`/billing-legacy/courses`);
  }, [history]);

  return (
    <>
      <BackButton onGoBack={onGoBack} title={course?.name} subtitle={intl.formatMessage({ id: 'courses' })} />
      <PaymentCourseDetails
        course={course}
        currentPeriod={currentPeriod}
        onSelectInvoice={onSelectInvoice}
        selectedInvoiceId={invoiceId}
        selectedInvoice={invoice}
        onSelectCurrentPeriod={onSelectCurrentPeriod}
        onDownloadPeriodReport={onDownloadPeriodData}
      />
    </>
  );
};

export default CourseBillingPage;
